import * as React from 'react';
import { connect } from 'react-redux';

import RolesList from '../../common/RolesList/RolesList';
import { RolesTableData, RolesTableState } from '../../common/types';
import { CLEAR_FILTERS, ROLE_FILTER_REMOVED } from '../../redux/actions/action-types';
import { State } from '../../redux/configure-store';
import { InviteStatusType } from '../../services/server-types';
import { InviteData, TeamMembersByRoles, UserData } from '../../types/teamMembers';
import { getUserRoles } from '../../redux/selectors/teamMembers';
import { showModal } from '../../redux/actions/activeModal.actions';
import { ModalName } from '../../types/ModalNames';
import { Role } from '../../types/roles';
import { isOwner } from '../../redux/selectors/roleAreas';

type ImapStateToProps = (state: State) => {
  usersByRoles: TeamMembersByRoles<UserData>;
  invitesByRoles: TeamMembersByRoles<InviteData>;
  isOwner: boolean
};

const mapStateToProps: ImapStateToProps = (state) => {
  const pendingInvites = state.teamMembers.invites.filter(invite => invite.status === InviteStatusType.PENDING);
  return {
    usersByRoles: mapTeamMembersByRoles<UserData>(state.teamMembers.users),
    invitesByRoles: mapTeamMembersByRoles<InviteData>(pendingInvites),
    isOwner: getUserRoles(state, state.teamDetails.targetAccountId).some(role => isOwner(state, role)),
  };
};

export const queryRolesTable = (roles: RolesTableData, rolesTableState: RolesTableState) => {
  if (rolesTableState.query) {
    const query = rolesTableState.query.toLocaleLowerCase();
    return roles.filter(role => {
      const searchableProps = [role.title, role.description];

      return searchableProps.map(prop => (prop || '').toLocaleLowerCase()).find((prop => prop.includes(query) || query.includes(prop)));
    });
  }

  return roles;
};

const mapTeamMembersByRoles: <T extends UserData | InviteData>(members: T[]) => TeamMembersByRoles<T> = (members) => {
  return members.reduce((acc, member) => {
    member.roles.forEach(role => {
        if (acc[role]) {
          acc[role].push(member);
        } else {
          acc[role] = [member];
        }
    });
    return acc;
  }, {});
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onRoleSelected: (selectRoleId: string) => {

    dispatch({ type: CLEAR_FILTERS });
    // In order to hide all the roles but the one the user clicked on we need to pass them all as array to the members table state
    dispatch({ type: ROLE_FILTER_REMOVED, value: ownProps.roleIds.filter(role => role !== selectRoleId) });
  },
  onRemoveRequest: (role: Role) => {
    dispatch(showModal(ModalName.RemoveRole, { idToRemove: role.id, roleName: role.title }));
  },
  onCannotRemoveRole: (role: Role, numOfContributors: number, roles: Role[]) => {
    dispatch(showModal(ModalName.CannotRemoveRole, { numOfContributors, roleName: role.title, roleId: role.id, roles }));
  }
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(RolesList);
